<template>
  <a-drawer :visible="visible" @close="onClose" :title="title" width="35%">
    <a-form-model>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="设备类型" prop="type">
            <!-- <a-input v-model="deviceForm.type" /> -->
            <a-select v-model="deviceForm.type">
              <a-select-option v-for="item in deviceTypeList" :key="item.id" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="设备状态" prop="status">
            <!-- <a-input v-model="deviceForm.type" /> -->
            <a-select v-model="deviceForm.status">
              <a-select-option v-for="item in deviceStatusList" :key="item.id" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item></a-col>
        <a-col :span="24">
          <a-form-model-item required label="设备编号">
            <a-input v-model="deviceForm.code" type="text"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item required label="设备名称">
            <a-input v-model="deviceForm.name" type="text"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="站号地址" prop="name">
            <a-input v-model="deviceForm.deviceAddress" type="text"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item required label="规格型号">
            <a-input v-model="deviceForm.model" type="text"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item required label="品牌">
            <a-input v-model="deviceForm.brand" type="text"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="客户" prop="customerId">
            <a-select
              show-search
              v-model="deviceForm.customerId"
              placeholder="搜索客户"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearchCustomer"
              @popupScroll="handlePopupScroll"
              @blur="handleBlur"
            >
              <a-select-option v-for="d in customerResultList" :key="d.id">
                {{ d.company }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="安装位置">
            <a-input v-model="deviceForm.installAddress" type="text"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="驱动类型" prop="driverType">
            <a-select style="width: 100%;" disabled v-model="deviceForm.driverType">
              <a-select-option v-for="drive in driveTypeList" :key="drive.value">
                {{ drive.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="协议编号" prop="protocolCode" style="position: relative;">
          <a-select
            show-search
            v-model="deviceForm.protocolCode"
            placeholder="搜索协议"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="handleSearchProtocol"
            @popupScroll="handleProtocolPopupScroll"
            @blur="handleBlur"
            @change="handleChange"
          >
            <a-select-option v-for="d in protocolList" :key="d.code">
              {{ d.code }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item required label="模块编号">
            <a-input v-model="deviceForm.dtuCode" type="text"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="度量" prop="measurement">
            <a-input v-model="deviceForm.measurement" type="text"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item required label="初始值">
            <a-input v-model="deviceForm.initialValue" type="text"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="备注">
            <a-textarea
              :auto-size="{ minRows: 3, maxRows: 5 }"
              v-model="deviceForm.remark"
            ></a-textarea>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="功率">
            <a-input v-model="deviceForm.power" type="text"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="压力">
            <a-input v-model="deviceForm.pressure" type="text"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="质保年限" style="margin-bottom: 36px;">
            <a-input v-model="deviceForm.warrantyPeriod" type="text"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div
      :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
    >
      <a-space>
        <a-button @click="onClose">取消</a-button>
        <a-button type="primary" @click="save">保存</a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getDict } from '@/api/dict'
import { updateDevice } from '@/api/device'
import { searchCustomerList, getCustomerById } from '@/api/customer'
import { searchProtocolCode } from '@/api/protocol'
import debounce from '@/components/function/debounce'

const queryParams = {
  query: [
    {
      field: 'company',
      value: ''
    }
  ],
  filter: [],
  sort: []
}

export default {
  name: 'EquipmentDrawer',
  props: {
    visible: {
      default: false,
      type: Boolean
    },
    type: {
      default: 0,
      type: Number
    },
    equipment: Object,
    closeDrawer: Function
  },
  mounted () {
    // protocolApi.listAll().then(({ data }) => {
    //   this.protocolList = data
    // })
    getDict('zh-CN', 'deviceType').then(({ data }) => {
      this.deviceTypeList = data.content
    })
    getDict('zh-CN', 'deviceStatus').then(({ data }) => {
      this.deviceStatusList = data.content
    })
    getDict('zh-CN', 'driverType').then(({ data }) => {
      this.driveTypeList = data.content
    })
  },
  data () {
    return {
      deviceForm: {
        code: '',
        name: '',
        model: '',
        brand: '',
        customerId: 0,
        companyName: '',
        address: '',
        driverType: '',
        protocolCode: '',
        dtuCode: '',
        remark: '',
        initialValue: 0
      },
      driveTypeList: [],
      protocolList: [],
      customerResultList: [],
      companyList: [],
      deviceTypeList: [],
      deviceStatusList: [],
      protocolPage: 1,
      page: 1
    }
  },
  computed: {
    title () {
      switch (this.type) {
        case 0: return '设备信息'
        case 1: return '新增设备'
        case 2: return '编辑设备'
        default: return ''
      }
    }
  },
  watch: {
    equipment: {
      handler (val, oldVal) {
        this.deviceForm = { ...val }
        getCustomerById(val.customerId).then(({ data }) => {
          this.customerResultList = [data]
        })
      },
      deep: true
    }
  },
  methods: {
    onClose () {
      this.$emit('close', false)
    },
    searchCustomer (value) {
      value = value.trim()
      deviceApi.searchCustomer(value).then(data => {
        this.companyList = data.data
        this.customerResultList = []
        data.data.forEach(customer => {
          this.customerResultList.push(customer.companyName)
        })
      }).catch(() => {
        // this.$message.error("请求失败")
      })
    },
    async handlePopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.page++
        const { data } = await searchCustomerList(this.page, 10, queryParams)
        this.customerResultList = this.customerResultList.concat(data.records)
      }
    },
    selectCustomer (value) {
      const customer = this.companyList.find(company => company.companyName === value)
      this.deviceForm.customerId = customer.id
      this.deviceForm.companyName = customer.companyName
    },
    selectProtocol (value, option) {
      const res = this.protocolList.find(item => item.protocolCode === value)
      this.deviceForm.driverType = res.driverType
    },
    save () {
      this.deviceForm.initialValue = +this.deviceForm.initialValue
      const f = {
        id: this.deviceForm.id,
        code: this.deviceForm.code,
        name: this.deviceForm.name,
        type: this.deviceForm.type,
        status: this.deviceForm.status,
        model: this.deviceForm.model,
        brand: this.deviceForm.brand,
        customerId: this.deviceForm.customerId,
        installAddress: this.deviceForm.installAddress,
        driverType: this.deviceForm.driverType,
        protocolCode: this.deviceForm.protocolCode,
        measurement: this.deviceForm.measurement,
        dtuCode: this.deviceForm.dtuCode,
        remark: this.deviceForm.remark,
        pressure: this.deviceForm.pressure,
        power: this.deviceForm.power,
        warrantyPeriod: null,
        tag: this.deviceForm.tag || null
      }
      updateDevice(f).then(({ message }) => {
        this.$message.success(message)
        this.closeDrawer()
      }).catch(() => {
        // this.$message.error("请求失败")
      })
    },
    handleBlur() {
      this.page = 1
      this.userList = []
      this.$forceUpdate()
    },
    handleSearchCustomer(value) {
      debounce(async () => {
        try {
          queryParams.query[0].value = value
          const { data } = await searchCustomerList(this.page, 10, queryParams)
          this.customerResultList = data.records
          this.page = 1
        } catch(e) {
          console.log(e)
        }
      }, 300)
    },
    handleSearchProtocol(value) {
      debounce(async () => {
        try {
          const { data } = await searchProtocolCode(this.protocolPage, 10, value, '')
          this.protocolList = data.records
          this.protocolPage = 1
        } catch(e) {
          console.log(e)
        }
      }, 300)
    },
    handleChange(value) {
      const p = this.protocolList.find(p => p.code === value)
      this.deviceForm.driverType = p.driver
    },
    async handleProtocolPopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.protocolPage++
        const { data } = await searchProtocolCode(this.protocolPage, 10, value, '')
        this.protocolList = this.protocolList.concat(data.records)
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
